import { NavLink } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import {
  CalendarIcon,
  ClipboardListIcon,
  GearIcon,
  HomeIcon,
  IdCardIcon,
  Logo,
  Paragraph,
  PrescriptionIcon,
  SignOutIcon,
  TruckFastIcon,
} from '@quickmd-llc/design-system'
import { LOGOUT } from 'store/auth/AuthConstants'
import {
  ACCOUNT_SETTINGS_PAGE_PATH,
  CALENDAR_PAGE_PATH,
  MEDICATIONS_PAGE_PATH,
  PATIENTS_CHARTS_PAGE_PATH,
  TRACKING_PAGE_PATH,
  VISITS_PAGE_PATH,
  WAITING_ROOM_PAGE_PATH,
} from 'utils/constants'
import { RouteGate } from 'components/RouteGate'

const navigationItems = [
  { icon: HomeIcon, label: 'Home', path: WAITING_ROOM_PAGE_PATH },
  { icon: CalendarIcon, label: 'Scheduling', path: CALENDAR_PAGE_PATH },
  { icon: ClipboardListIcon, label: 'Visits', path: VISITS_PAGE_PATH },
  { icon: IdCardIcon, label: 'Patients', path: PATIENTS_CHARTS_PAGE_PATH },
  { icon: PrescriptionIcon, label: 'Medications', path: MEDICATIONS_PAGE_PATH },
  { icon: TruckFastIcon, label: 'Tracking', path: TRACKING_PAGE_PATH },
]

export function Navigation() {
  const dispatch = useDispatch()

  function handleClickLogOut() {
    dispatch({ type: LOGOUT, reason: 'manual' })
  }

  return (
    <div className='tailwind-scoped'>
      <div className='flex h-full flex-col justify-between p-sp-2'>
        <div className='grid gap-sp-3'>
          <Logo variant='full' size='s' />

          <div className='grid gap-sp-2'>
            {navigationItems.map(({ icon: Icon, label, path }) => (
              <RouteGate path={path} key={label}>
                <NavLink
                  to={path}
                  className='group flex items-center gap-sp-1 rounded-lg p-sp-1 aria-[current=page]:bg-coastal-blue-10'>
                  <Icon
                    className='text-text-light group-hover:text-text-dark group-aria-[current=page]:text-text-highlight'
                    iconSize='l'
                  />
                  <Paragraph
                    size='sm'
                    className='font-sans font-semibold text-text-light group-hover:text-text-dark group-aria-[current=page]:text-text-highlight'>
                    {label}
                  </Paragraph>
                </NavLink>
              </RouteGate>
            ))}
          </div>
        </div>

        <div className='grid gap-sp-2'>
          <RouteGate path={ACCOUNT_SETTINGS_PAGE_PATH}>
            <NavLink to={ACCOUNT_SETTINGS_PAGE_PATH} className='group flex items-center gap-sp-1 rounded-lg p-sp-1'>
              <GearIcon className='text-text-light group-hover:text-text-dark' iconSize='l' />
              <Paragraph size='sm' className='font-sans font-semibold text-text-light group-hover:text-text-dark'>
                Settings
              </Paragraph>
            </NavLink>
          </RouteGate>

          <div
            className='group flex cursor-pointer items-center gap-sp-1 rounded-lg p-sp-1'
            onClick={handleClickLogOut}
            role='button'
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                handleClickLogOut()
              }
            }}>
            <SignOutIcon className='text-text-light group-hover:text-text-dark' iconSize='l' />
            <Paragraph size='sm' className='font-sans font-semibold text-text-light group-hover:text-text-dark'>
              Sign out
            </Paragraph>
          </div>
        </div>
      </div>
    </div>
  )
}
